import { render, staticRenderFns } from "./groupHeader.vue?vue&type=template&id=686a8fac&"
import script from "./groupHeader.vue?vue&type=script&lang=js&"
export * from "./groupHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports